import { BrowserRouter, Route, Routes } from "react-router-dom";
import Navbar from "./components/Navbar";
import Protected from "./components/Protected";
import {
  Login,
  AdminLogin,
  AdminPanel,
  Dash,
  Feedback,
  Contact,
  FAQPage,
  AlumniReg,
} from "./pages";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/css/bootstrap.min.css";

function App() {
  return (
    <>
      <BrowserRouter>
        <Navbar />
        <Routes>
          <Route path='/login' element={<Login />} />
          <Route path='/admin/login' element={<AdminLogin />} />
          <Route path='/admin-login' element={<AdminLogin />} />
          <Route
            path='/admin'
            element={
              <Protected>
                <AdminPanel />
              </Protected>
            }
          />
          <Route
            path='/admin/dashboard'
            element={
              <Protected>
                <AdminPanel />
              </Protected>
            }
          />
          <Route
            path='/'
            element={
              <Protected>
                <Dash />
              </Protected>
            }
          />
          <Route
            path='/feedback'
            element={
              <Protected>
                <Feedback />
              </Protected>
            }
          />
          <Route path='/contact' element={<Contact />} />
          <Route path='/faq' element={<FAQPage />} />
          <Route path='/alumni-reg' element={<AlumniReg />} />
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
